/**
 * Shared layout types for Public Dashboard sections.
 * These are the data-shape types persisted in `section.style.layout` and
 * consumed by both frontend (rendering, editing) and backend (migration,
 * duplication, audit). No runtime dependencies — pure types and constants.
 */
/** Fluid grid configuration (24 columns, 25px rows). */
export const FLUID_GRID = {
    columns: 24,
    rows: 12,
    rowHeight: 25,
    margin: [11, 11],
    containerPadding: [11, 11],
};
/** Default fluid section layout. Mobile uses single-column stack. */
export const DEFAULT_FLUID_SECTION_LAYOUT = {
    engineType: "fluid",
    current: "desktop",
    gridByBreakpoint: {
        desktop: FLUID_GRID,
        tablet: { ...FLUID_GRID, columns: 16 },
        mobile: { ...FLUID_GRID, columns: 1 },
    },
    itemsByBreakpoint: { desktop: {}, tablet: {}, mobile: {} },
};
function isObject(value) {
    return typeof value === "object" && value !== null;
}
/**
 * Get the engine type from a section layout JSON value.
 * Returns "legacy" for undefined/unknown values (backward compatibility).
 */
export function getEngineType(layout) {
    if (!isObject(layout))
        return "legacy";
    return layout.engineType === "fluid" ? "fluid" : "legacy";
}
/** Check if a section layout uses the fluid engine. */
export function isFluidEngine(layout) {
    return getEngineType(layout) === "fluid";
}
